import cloneDeep from 'lodash/fp/cloneDeep'

const UNMODIFIED = 'unmodified'
const DELETED = 'deleted'
const ADDED = 'added'
const MODIFIED = 'modified'

export const modificationStates = {
  added: ADDED,
  deleted: DELETED,
  unmodified: UNMODIFIED,
  modified: MODIFIED
}

function assignModificationState (oldListItem, newList, uniqueIdentifierProperty, itemWasModified) {
  var modificationState = UNMODIFIED
  var found = false
  var currentIndex = 0
  let newItem

  const identifiers = Array.isArray(uniqueIdentifierProperty)
    ? uniqueIdentifierProperty
    : [uniqueIdentifierProperty]

  while (!found && newList.length > currentIndex) {
    const candidate = newList[currentIndex]
    const allMatch = identifiers.every(prop => oldListItem[prop] === candidate[prop])
    if (allMatch) {
      found = true
      newItem = candidate
    }
    currentIndex++
  }

  if (!found) {
    modificationState = DELETED
  } else if (itemWasModified) {
    modificationState = itemWasModified(oldListItem, newItem, modificationState.modified, modificationStates.unmodified)
  }

  return { ...oldListItem, modificationState }
}

export function listDifferenceComputer (oldList, newList, uniqueIdentifierProperty, itemWasModified) {
  var modifications = cloneDeep(oldList).map(oldListItem =>
    assignModificationState(oldListItem, newList, uniqueIdentifierProperty, itemWasModified)
  )

  const identifiers = Array.isArray(uniqueIdentifierProperty)
    ? uniqueIdentifierProperty
    : [uniqueIdentifierProperty]

  const newListItems = newList
    .filter(newListItem =>
      !modifications.some(oldListItem =>
        identifiers.every(prop => oldListItem[prop] === newListItem[prop])
      )
    )
    .map(newListItem => ({ ...newListItem, modificationState: ADDED }))

  return modifications.concat(newListItems)
}
